<template>
	<div class="main-content">
		<!-- HEADER -->
		<div class="header">
			<div class="container-fluid">
				<div :class="`card mt-5`" v-if="permission == false">
					<div class="card-body">
						<div class="row align-items-center">
							<div class="col-12 col-md-6 offset-xl-2 offset-md-1 order-md-2 mb-5 mb-md-0">
								<!-- Image -->
								<div class="text-center">
									<img src="../../src/assets/img/illustrations/download.svg" alt="..." class="img-fluid" />
								</div>
							</div>
							<div class="col-12 col-md-5 col-xl-4 order-md-1 my-5">
								<div class="text-center">
									<!-- Preheading -->

									<!-- Heading -->
									<h1 class="display-4 mb-3">You don't have permission here</h1>

									<!-- Subheading -->
									<p class="text-body-secondary mb-4">Please call admin to have access here</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div :class="`card mt-5 `" v-if="permission == true">
					<div class="card-body">
						<div class="row justify-content-between align-items-center">
							<div class="col-12 col-md-9 col-xl-7">
								<!-- Heading -->
								<h2 class="mb-2">Dashboard</h2>
								<div>
									<p class="mb-md-0"><b>Plan Info</b></p>
									<p class="mb-md-0">Budget Plan Title: {{ this.activePlan?.title }}</p>
									<p class="mb-md-0">
										Department:
										{{ this.activePlan?.fund_center?.department_code }} -
										{{ this.activePlan?.fund_center?.department_name }}
									</p>
									<p class="mb-md-0">Year: {{ this.activePlan?.year }}</p>
									<p class="mb-md-0">Version: {{ this.activePlan?.version }}</p>
								</div>
							</div>
							<div class="col-12 col-md-auto" v-if="roles != 'User'">
								<b-dropdown id="dropdown-1" right text="Report" variant="primary">
									<b-dropdown-item @click="downloadExcel('Budget Plan')">Budget Plan</b-dropdown-item>
									<b-dropdown-item @click="downloadExcel('Actual Budget')">Budget Realization</b-dropdown-item>
									<b-dropdown-item @click="downloadExcel('Budget Monitoring')">Budget Monitoring</b-dropdown-item>
									<b-dropdown-item @click="downloadExcel('Budget Relocation')">Budget Relocation</b-dropdown-item>
								</b-dropdown>
								<!-- <button class="btn btn-primary lift" data-bs-toggle="modal" data-bs-target="#exampleModal"
                  @click="kons()">
                  <span class="fe fe-folder-plus"></span>
                  Report
                </button> -->
							</div>
						</div>
					</div>
				</div>
				<!-- Body -->
			</div>
		</div>
		<!-- / .header -->

		<!-- CARDS -->
		<div :class="`container-fluid ${permission == true ? 'd-block' : 'd-none'}`">
			<div class="accordion" role="tablist">
				<b-card no-body class="mb-4">
					<b-card-header header-tag="header" class="p-4" role="tab" v-b-toggle.accordion-1>
						<div class="d-flex justify-content-between">
							Filter
							<span v-if="isAccordionOpen" class="fe fe-chevron-up"></span>
							<span v-else class="fe fe-chevron-down"></span>
						</div>
					</b-card-header>
					<b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel" v-model="isAccordionOpen">
						<div class="card-body">
							<div class="row"></div>
							<div class="row">
								<div class="form-group col-3 align-items-start pl-0">
									<label>Department</label>
									<v-select
										:options="listDepartement"
										v-model="formFilter.fund_center_id"
										:reduce="(e) => e.value"
										placeholder="Select/Type Here..."
										class="w-md-auto"
										@input="selectedDepartment()"
									/>
								</div>
								<div class="form-group col-3 align-items-start pl-0">
									<label>Year</label>
									<v-select :options="listDataYear" label="year" v-model="tempYears" @input="selectedYear()" />
								</div>
								<div class="form-group col-3 align-items-start pl-0">
									<label>Plan</label>
									<input name="budget_title" type="text" class="form-control" v-model="this.plan_title" disabled />
								</div>
							</div>
							<div class="row">
								<div class="form-group col-3 align-items-start pl-0">
									<label>Version</label>
									<v-select :options="listDataVersion" label="version" :reduce="(e) => e.version" v-model="formFilter.version" />
								</div>
								<div class="form-group col-3 align-items-start pl-0">
									<label>Month</label>
									<v-select
										:options="monthData"
										label="label"
										:reduce="(e) => e.value"
										v-model="formFilter.month"
										:clearable="!formFilter.week"
										:disabled="!formFilter.year"
									></v-select>
								</div>
								<div class="form-group col-3 align-items-start pl-0">
									<label>Week</label>
									<v-select
										:options="weekData"
										label="label"
										:reduce="(e) => e.value"
										v-model="formFilter.week"
										:disabled="!formFilter.month"
									></v-select>
								</div>
								<div class="form-group col-3 align-items-start pl-0">
									<div class="mt-3 pt-3">
										<b-button class="mr-2" variant="outline-primary" @click="resetAll">Reset </b-button>
										<b-button variant="primary" @click="getAllDashboard()">Search </b-button>
									</div>
								</div>
							</div>
						</div>
						<!--            <b-card-body>
              <div class="row">
                <div class="col-lg-3">
                  <div class="form-group">
                    <label>Year</label>
                    <date-picker type="year" v-model="filter.year" style="width: 100%;" value-type="format"
                      format="YYYY" placeholder="Select year" :clearable="!filter.month" :disabled="!filter.id">
                    </date-picker>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label>Month</label>
                    <v-select :options="monthData" label="label" :reduce="((e) => e.value)" v-model="filter.month"
                      :clearable="!filter.week" :disabled="!filter.year"></v-select>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label>Week</label>
                    <v-select :options="weekData" label="label" :reduce="((e) => e.value)" v-model="filter.week"
                      :disabled="!filter.month"></v-select>
                  </div>
                </div>

              </div>
            </b-card-body>-->
					</b-collapse>
				</b-card>
			</div>
			<div class="row" v-if="roles != 'User'">
				<div class="col-12">
					<div class="card">
						<div class="card-body row">
							<b-tabs v-model="activeTabIndex" class="col-12" content-class="mt-0" pills fill card>
								<b-tab title="General Budget" active>
									<div class="row align-items-center mt-0">
										<div class="col-lg-3">
											<div class="col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">TOTAL PLAN OPEX</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.general_plan?.summary.budget.plan_budget.opex) }}
												</span>
											</div>
											<div class="mt-5 col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">TOTAL ACTUAL OPEX (incl. Relocate Out)</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.general_plan?.summary.budget.actual_budget.opex) }}
												</span>
											</div>
											<div class="mt-5 col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">TOTAL REMAINING OPEX (incl. Relocate In)</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.general_plan?.summary.budget.remaining_budget.opex) }}
												</span>
											</div>
										</div>
										<div class="col-lg-3">
											<div class="col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">TOTAL PLAN CAPEX</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.general_plan?.summary.budget.plan_budget.capex) }}
												</span>
											</div>
											<div class="mt-5 col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">TOTAL ACTUAL CAPEX (incl. Relocate Out)</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.general_plan?.summary.budget.actual_budget.capex) }}
												</span>
											</div>
											<div class="mt-5 col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">TOTAL REMAINING CAPEX (incl. Relocate In)</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.general_plan?.summary.budget.remaining_budget.capex) }}
												</span>
											</div>
										</div>
										<div class="col-lg-3">
											<div class="col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">TOTAL PLAN</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.general_plan?.summary.budget.plan_budget.total) }}
												</span>
											</div>
											<div class="mt-5 col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">TOTAL ACTUAL (incl. Relocate Out)</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.general_plan?.summary.budget.actual_budget.total) }}
												</span>
											</div>
											<div class="mt-5 col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">TOTAL REMAINING (incl. Relocate In)</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.general_plan?.summary.budget.remaining_budget.total) }}
												</span>
											</div>
										</div>
										<div class="col-lg-3">
											<div class="col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">TOTAL PAYMENT OPEX</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.general_plan?.summary.budget.actual_payment.opex) }}
												</span>
											</div>
											<div class="mt-5 col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">TOTAL PAYMENT CAPEX</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.general_plan?.summary.budget.actual_payment.capex) }}
												</span>
											</div>
											<div class="mt-5 col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">TOTAL PAYMENT (OPEX + CAPEX)</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.general_plan?.summary.budget.actual_payment.total) }}
												</span>
											</div>
										</div>
									</div>
									<!-- / .row -->
								</b-tab>

								<b-tab title="Budget Relocation">
									<div class="row align-items-center mb-4 gx-0">
										<div class="col-lg-4">
											<div class="col-lg-12">
												<!-- Title -->
												<div class="flex-column text-left">
													<h6 class="text-uppercase text-body-secondary mb-2">
														TOTAL RELOCATE IN OPEX
														<i
															class="fe fe-help-circle text-danger fs-4"
															style="cursor: help"
															v-b-popover.hover.right="
																`Jumlah dari seluruh budget relokasi dari department lain ke department ${this.activePlan?.fund_center?.department_name} ditambah budget relokasi yang masuk dari relokasi internal department ${this.activePlan?.fund_center?.department_name}  pada expense bertipe OPEX`
															"
															variant="secondary"
														></i>
													</h6>
												</div>
												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.general_plan?.summary.relocate_budget.relocate_in.opex) }}
												</span>
											</div>

											<div class="mt-5 col-lg-12">
												<!-- Title -->
												<div class="flex-column text-left">
													<h6 class="text-uppercase text-body-secondary mb-2">
														TOTAL RELOCATE OUT OPEX
														<i
															class="fe fe-help-circle text-danger fs-4"
															style="cursor: help"
															v-b-popover.hover.right="
																`Jumlah dari seluruh budget relokasi dari department ${this.activePlan?.fund_center?.department_name} ke department lain ditambah budget relokasi yang keluar dari relokasi internal department ${this.activePlan?.fund_center?.department_name}  pada expense bertipe OPEX`
															"
															variant="secondary"
														></i>
													</h6>
												</div>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.general_plan?.summary.relocate_budget.relocate_out.opex) }}
												</span>
											</div>
										</div>
										<div class="col-lg-4">
											<div class="col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">
													TOTAL RELOCATE IN CAPEX
													<i
														class="fe fe-help-circle text-danger fs-4"
														style="cursor: help"
														v-b-popover.hover.right="
															`Jumlah dari seluruh budget relokasi dari department lain ke department ${this.activePlan?.fund_center?.department_name} ditambah budget relokasi yang masuk dari relokasi internal department ${this.activePlan?.fund_center?.department_name}  pada expense bertipe CAPEX`
														"
														variant="secondary"
													></i>
												</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.general_plan?.summary.relocate_budget.relocate_in.capex) }}
												</span>
											</div>
											<div class="mt-5 col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">
													TOTAL RELOCATE OUT CAPEX
													<i
														class="fe fe-help-circle text-danger fs-4"
														style="cursor: help"
														v-b-popover.hover.right="
															`Jumlah dari seluruh budget relokasi dari department ${this.activePlan?.fund_center?.department_name} ke department lain ditambah budget relokasi yang keluar dari relokasi internal department ${this.activePlan?.fund_center?.department_name}  pada expense bertipe CAPEX`
														"
														variant="secondary"
													></i>
												</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.general_plan?.summary.relocate_budget.relocate_out.capex) }}
												</span>
											</div>
										</div>
										<div class="col-lg-4">
											<div class="col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">
													TOTAL RELOCATE IN
													<i
														class="fe fe-help-circle text-danger fs-4"
														style="cursor: help"
														v-b-popover.hover.right="`Jumlah dari Total Relocate IN OPEX + Total Relocate IN CAPEX`"
														variant="secondary"
													></i>
												</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.general_plan?.summary.relocate_budget.relocate_in.total) }}
												</span>
											</div>
											<div class="mt-5 col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">
													TOTAL RELOCATE OUT
													<i
														class="fe fe-help-circle text-danger fs-4"
														style="cursor: help"
														v-b-popover.hover.right="`Jumlah dari Total Relocate OUT OPEX + Total Relocate OUT CAPEX`"
														variant="secondary"
													></i>
												</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.general_plan?.summary.relocate_budget.relocate_out.total) }}
												</span>
											</div>
										</div>
									</div>
									<!-- / .row -->
									<div class="row align-items-center gx-0">
										<div class="col-lg-4">
											<div class="col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">
													TOTAL RELOCATE INTERNAL IN OPEX
													<i
														class="fe fe-help-circle text-danger fs-4"
														style="cursor: help"
														v-b-popover.hover.right="
															`Jumlah dari seluruh budget relokasi internal department ${this.activePlan?.fund_center?.department_name} yang masuk ke budget task dari tipe expense OPEX`
														"
														variant="secondary"
													></i>
												</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.general_plan?.summary.relocate_budget.relocate_int_int_to.opex) }}
												</span>
											</div>

											<div class="mt-5 col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">
													TOTAL RELOCATE INTERNAL OUT OPEX
													<i
														class="fe fe-help-circle text-danger fs-4"
														style="cursor: help"
														v-b-popover.hover.right="
															`Jumlah dari seluruh budget relokasi internal department ${this.activePlan?.fund_center?.department_name} yang keluar dari budget task tipe expense OPEX`
														"
														variant="secondary"
													></i>
												</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.general_plan?.summary.relocate_budget.relocate_int_int_from.opex) }}
												</span>
											</div>
										</div>
										<div class="col-lg-4">
											<div class="col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">
													TOTAL RELOCATE INTERNAL IN CAPEX
													<i
														class="fe fe-help-circle text-danger fs-4"
														style="cursor: help"
														v-b-popover.hover.right="
															`Jumlah dari seluruh budget relokasi internal department ${this.activePlan?.fund_center?.department_name} yang masuk ke budget task dari tipe expense CAPEX`
														"
														variant="secondary"
													></i>
												</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.general_plan?.summary.relocate_budget.relocate_int_int_to.capex) }}
												</span>
											</div>
											<div class="mt-5 col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">
													TOTAL RELOCATE INTERNAL OUT CAPEX
													<i
														class="fe fe-help-circle text-danger fs-4"
														style="cursor: help"
														v-b-popover.hover.right="
															`Jumlah dari seluruh budget relokasi internal department ${this.activePlan?.fund_center?.department_name} yang keluar dari budget task tipe expense CAPEX`
														"
														variant="secondary"
													></i>
												</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.general_plan?.summary.relocate_budget.relocate_int_int_from.capex) }}
												</span>
											</div>
										</div>
										<div class="col-lg-4">
											<div class="col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">
													TOTAL RELOCATE INTERNAL IN
													<i
														class="fe fe-help-circle text-danger fs-4"
														style="cursor: help"
														v-b-popover.hover.right="`Jumlah dari Total Relocate Internal IN OPEX + Total Relocate Internal IN CAPEX`"
														variant="secondary"
													></i>
												</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.general_plan?.summary.relocate_budget.relocate_int_int_to.total) }}
												</span>
											</div>
											<div class="mt-5 col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">
													TOTAL RELOCATE INTERNAL OUT
													<i
														class="fe fe-help-circle text-danger fs-4"
														style="cursor: help"
														v-b-popover.hover.right="
															`Jumlah dari Total Relocate Internal OUT OPEX + Total Relocate Internal OUT CAPEX`
														"
														variant="secondary"
													></i>
												</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.general_plan?.summary.relocate_budget.relocate_int_int_from.total) }}
												</span>
											</div>
										</div>
									</div>
									<!-- / .row -->
								</b-tab>

								<b-tab title="Budget Approved">
									<div class="row align-items-center mt-0">
										<div class="col-lg-4">
											<div class="col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">TOTAL PLAN OPEX</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.approved_plan?.summary.budget.plan_budget.opex) }}
												</span>
											</div>
											<div class="mt-5 col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">TOTAL ACTUAL OPEX (incl. Relocate Out)</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.approved_plan?.summary.budget.actual_budget.opex) }}
												</span>
											</div>
											<div class="mt-5 col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">TOTAL REMAINING OPEX (incl. Relocate In)</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.approved_plan?.summary.budget.remaining_budget.opex) }}
												</span>
											</div>
										</div>
										<div class="col-lg-4">
											<div class="col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">TOTAL PLAN CAPEX</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.approved_plan?.summary.budget.plan_budget.capex) }}
												</span>
											</div>
											<div class="mt-5 col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">TOTAL ACTUAL CAPEX (incl. Relocate Out)</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.approved_plan?.summary.budget.actual_budget.capex) }}
												</span>
											</div>
											<div class="mt-5 col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">TOTAL REMAINING CAPEX (incl. Relocate In)</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.approved_plan?.summary.budget.remaining_budget.capex) }}
												</span>
											</div>
										</div>
										<div class="col-lg-4">
											<div class="col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">TOTAL PLAN</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.approved_plan?.summary.budget.plan_budget.total) }}
												</span>
											</div>
											<div class="mt-5 col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">TOTAL ACTUAL (incl. Relocate Out)</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.approved_plan?.summary.budget.actual_budget.total) }}
												</span>
											</div>
											<div class="mt-5 col-lg-12">
												<!-- Title -->
												<h6 class="text-uppercase text-body-secondary mb-2">TOTAL REMAINING (incl. Relocate In)</h6>

												<!-- Heading -->
												<span class="h2 mb-0">
													Rp. {{ convertNumber(allMonitor.approved_plan?.summary.budget.remaining_budget.total) }}
												</span>
											</div>
										</div>
									</div>
									<!-- / .row -->
								</b-tab>

								<b-tab disabled>
									<template v-slot:title>
										<div class="align-items-left pt-3 mt-md-n4 mb-0">
											<div class="d-flex flex-column text-left">
												<span class="mb-1 tab-title">Budget Plan Version</span>
												<span class="border border-danger text-danger px-3 py-1 rounded w-100">
													{{ approvedPlanVersion }}
												</span>
											</div>
										</div>
									</template>
								</b-tab>
							</b-tabs>
						</div>
					</div>
				</div>
			</div>
			<div class="row" v-if="roles != 'User'">
				<div class="col mb-4">
					<div class="card h-100">
						<div class="card-header">Top 10 Budget OPEX</div>
						<div class="card-body" style="padding: 0 !important">
							<div class="table-responsive mb-0">
								<table class="table table-sm table-nowrap card-table">
									<thead>
										<tr>
											<th>Rank</th>
											<th>Transaction Type</th>
											<th>Budget Item</th>
											<th>Total</th>
											<th class="text-end"></th>
										</tr>
									</thead>
									<tbody class="list">
										<tr v-for="(item, index) in opex" :key="index">
											<td class="goal-project">#{{ index + 1 }}</td>
											<td>
												{{ item?.account?.account }}
											</td>
											<td class="goal-status">{{ item.budget_item.item }} - {{ item.budget_item.budget_item }}</td>
											<td class="goal-progress">Rp. {{ convertNumber(item.summary?.totalActualBudget) }}</td>
											<td class="text-end">
												<div class="dropdown">
													<a href="#!" class="dropdown-ellipses dropdown-toggle" role="button" @click="openDetails(item, 'opex')">
														<i class="fe fe-more-vertical"></i>
													</a>
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
				<div class="col mb-4">
					<div class="card h-100">
						<div class="card-header">Top 10 Budget CAPEX</div>
						<div class="card-body" style="padding: 0 !important">
							<div class="table-responsive mb-0">
								<table class="table table-sm table-nowrap card-table">
									<thead>
										<tr>
											<th>Rank</th>
											<th>Budget Item</th>
											<th>Total</th>
											<th class="text-end"></th>
										</tr>
									</thead>
									<tbody class="list">
										<tr v-for="(item, index) in capex" :key="index">
											<td class="goal-project">#{{ index + 1 }}</td>
											<td class="goal-status">{{ item?.account?.code }} - {{ item?.account?.account }}</td>
											<td class="goal-progress">Rp. {{ convertNumber(item.summary?.totalActualBudget) }}</td>
											<td class="text-end">
												<div class="dropdown">
													<a href="#!" class="dropdown-ellipses dropdown-toggle" role="button" @click="openDetails(item, 'capex')">
														<i class="fe fe-more-vertical"></i>
													</a>
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12 col-md-6 col-lg-4">
					<div class="card">
						<div class="card-header">
							<!-- Title -->
							<h5 class="card-header-title">Total PO OPEX</h5>
						</div>
						<div class="card-body">
							<apexchart type="pie" width="100%" :options="chartOptions2" :series="series2"></apexchart>
						</div>
					</div>
				</div>
				<div class="col-12 col-md-6 col-lg-4">
					<div class="card">
						<div class="card-header">
							<!-- Title -->
							<h5 class="card-header-title">Total PO CAPEX</h5>
						</div>
						<div class="card-body">
							<apexchart type="pie" width="100%" :options="chartOptions" :series="series"></apexchart>
						</div>
					</div>
				</div>
				<div class="col-12 col-md-6 col-lg-4">
					<div class="card">
						<div class="card-header">
							<!-- Title -->
							<h5 class="card-header-title">Total PO CAPEX + OPEX</h5>
						</div>
						<div class="card-body">
							<apexchart class="text-center" type="pie" width="100%" :options="chartOptions3" :series="series3"> </apexchart>
						</div>
					</div>
				</div>
				<div class="col-12 col-md-6 col-lg-4">
					<div class="card">
						<div class="card-header">
							<!-- Title -->
							<h5 class="card-header-title">Total Actual Payment OPEX</h5>
						</div>
						<div class="card-body">
							<apexchart class="text-center" type="pie" width="100%" :options="chartOptions4" :series="series4"> </apexchart>
						</div>
					</div>
				</div>
				<div class="col-12 col-md-6 col-lg-4">
					<div class="card">
						<div class="card-header">
							<!-- Title -->
							<h5 class="card-header-title">Total Actual Payment CAPEX</h5>
						</div>
						<div class="card-body">
							<apexchart class="text-center" type="pie" width="100%" :options="chartOptions5" :series="series5"> </apexchart>
						</div>
					</div>
				</div>
				<div class="col-12 col-md-6 col-lg-4">
					<div class="card">
						<div class="card-header">
							<!-- Title -->
							<h5 class="card-header-title">Total Actual Payment CAPEX + OPEX</h5>
						</div>
						<div class="card-body">
							<apexchart class="text-center" type="pie" width="100%" :options="chartOptions6" :series="series6"> </apexchart>
						</div>
					</div>
				</div>
			</div>
		</div>
		<b-modal size="xl" id="modal-detail" :title="title" hide-footer>
			<table class="table table-sm table-bordered table-striped table-hover p-0">
				<thead class="table-light">
					<tr>
						<td>Rank</td>
						<td>Budget Task</td>
						<td>Description</td>
						<td>Total</td>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in topFiveDetails" :key="index">
						<td class="text-center" style="width: 70px">#{{ index + 1 }}</td>
						<td>{{ item.name }}</td>
						<td>{{ item.description }}</td>
						<td>Rp. {{ convertNumber(item.actual) }}</td>
					</tr>
				</tbody>
			</table>
		</b-modal>
	</div>
	<!-- / .main-content -->
</template>
<script>
// import Chart from 'chart.js'
import axiosIns from '@/api/axios';
import moment from 'moment';

export default {
	name: 'HomeView',
	computed: {
		allMonitor: {
			get() {
				return this.$store.getters['budgetMonitor/allMonitoring'];
			},
			set(value) {
				this.$store.commit('budgetMonitor/SET_MONITORING', value);
			},
		},
		report() {
			return this.$store.getters['budgetMonitor/report'];
		},
		opex() {
			return this.$store.getters['budgetMonitor/topOpex'];
		},
		capex() {
			return this.$store.getters['budgetMonitor/topCapex'];
		},
		topFiveDetails() {
			return this.details && this.details.length ? this.details.slice(0, 5) : [];
		},
		listPlanOptions() {
			const listData = this.$store.getters['budgetPlan/listData'];
			// Pastikan data ada dan valid
			if (!listData || !listData.data) {
				return [];
			}
			return listData.data.map((e) => ({
				label: `${e.title} - Version ${e.version}`,
				id: e.id,
				year: e.year,
			}));
		},
		approvedPlanVersion() {
			let version;
			switch (this.activeTabIndex) {
				case 0:
					version = `Version ${this.allMonitor.general_plan?.detail.version || 0}`;
					break;
				case 1:
					version = `Version ${this.allMonitor.general_plan?.detail.version || 0}`;
					break;
				case 2:
					version = `Version ${this.allMonitor.approved_plan?.detail.version || 0}`;
					break;
				default:
					version = 'Version -';
					break;
			}

			return version;
		},
		userIndetify() {
			return this.$store.getters['role/identity'];
		},
		// listPlan() {
		//   setInterval(() => {
		//     let part = this.$store.getters["budgetPlan/listData"].data
		//     let data = []
		//     if (part.length < 0) {
		//       data = part.map((e) => {
		//         return {
		//           label: `${e.title}`,
		//           id: e.id
		//         }
		//       })
		//     }

		//     return data
		//   }, 500)
		// },
	},
	data() {
		return {
			tempYears: {},
			plan_title: '',
			activePlan: [],
			departmentId: null,
			listDepartement: [],
			listDataPlan: [],
			listDataPlanDstinct: [],
			listDataVersion: [],
			listDataYear: [],
			activeTabIndex: 0,
			isAccordionOpen: false,
			permission: null,
			title: '',
			roles: '',
			details: null,
			formFilter: {
				fund_center_id: '',
				title: '',
				version: '',
				year: '',
				month: '',
				week: '',
			},
			filter: {
				id: '',
				year: '',
				month: null,
				week: null,
			},
			// chart 1
			series: [],
			monthData: [
				{
					label: 'January',
					value: 1,
				},
				{
					label: 'February',
					value: 2,
				},
				{
					label: 'March',
					value: 3,
				},
				{
					label: 'April',
					value: 4,
				},
				{
					label: 'May',
					value: 5,
				},
				{
					label: 'June',
					value: 6,
				},
				{
					label: 'July',
					value: 7,
				},
				{
					label: 'August',
					value: 8,
				},
				{
					label: 'September',
					value: 9,
				},
				{
					label: 'October',
					value: 10,
				},
				{
					label: 'November',
					value: 11,
				},
				{
					label: 'December',
					value: 12,
				},
			],
			weekData: [
				{
					label: 'Week 1',
					value: 1,
				},
				{
					label: 'Week 2',
					value: 2,
				},
				{
					label: 'Week 3',
					value: 3,
				},
				{
					label: 'Week 4',
					value: 4,
				},
			],
			chartOptions: {
				tooltip: {
					custom: function ({ series, seriesIndex, dataPointIndex, w }) {
						return `<div style="padding: 10px; background: ${seriesIndex == 0 ? '#3e8df3' : '#67e09c'}"><span>${
							seriesIndex == 0 ? 'PO CAPEX' : 'Remaining CAPEX'
						}: Rp. ${series[seriesIndex].toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')}</span></div>`;
					},
				},
				chart: {
					width: 180,
					type: 'pie',
				},
				labels: ['PO CAPEX', 'Remaining CAPEX'],
				legend: {
					position: 'bottom',
				},
				responsive: [
					{
						breakpoint: 480,
						options: {
							chart: {
								width: 200,
							},
							legend: {
								horizontalAlign: 'right',
							},
						},
					},
				],
			},

			// chart 2
			series2: [],
			chartOptions2: {
				tooltip: {
					custom: function ({ series, seriesIndex, dataPointIndex, w }) {
						return `<div style="padding: 10px; background: ${seriesIndex == 0 ? '#3e8df3' : '#67e09c'}"><span>${
							seriesIndex == 0 ? 'PO OPEX' : 'Remaining  OPEX'
						}: Rp. ${series[seriesIndex].toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')}</span></div>`;
					},
				},
				chart: {
					width: 180,
					type: 'pie',
				},
				labels: ['PO OPEX', 'Remaining OPEX'],
				legend: {
					position: 'bottom',
				},
				responsive: [
					{
						breakpoint: 480,
						options: {
							chart: {
								width: 200,
							},
							legend: {
								position: 'bottom',
							},
						},
					},
				],
			},

			// chart 3
			series3: [],
			chartOptions3: {
				tooltip: {
					custom: function ({ series, seriesIndex, dataPointIndex, w }) {
						return `<div style="padding: 10px; background: ${seriesIndex == 0 ? '#3e8df3' : '#67e09c'}"><span>${
							seriesIndex == 0 ? 'PO CAPEX + OPEX' : 'Total Remaining CAPEX + OPEX'
						}: Rp. ${series[seriesIndex].toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')}</span></div>`;
					},
				},
				chart: {
					width: 180,
					type: 'pie',
				},
				labels: ['PO CAPEX + OPEX', 'Total Remaining CAPEX + OPEX'],
				legend: {
					position: 'bottom',
				},
				responsive: [
					{
						breakpoint: 480,
						options: {
							chart: {
								width: 200,
							},
							legend: {
								position: 'bottom',
							},
						},
					},
				],
			},
			// chart 4
			series4: [],
			chartOptions4: {
				tooltip: {
					custom: function ({ series, seriesIndex, dataPointIndex, w }) {
						return `<div style="padding: 10px; background: ${seriesIndex == 0 ? '#3e8df3' : '#67e09c'}"><span>${
							seriesIndex == 0 ? 'Actual Payment OPEX' : 'Total Remaining Payment OPEX'
						}: Rp. ${series[seriesIndex].toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')}</span></div>`;
					},
				},
				chart: {
					width: 180,
					type: 'pie',
				},
				labels: ['Actual Payment OPEX', 'Total Remaining Payment OPEX'],
				legend: {
					position: 'bottom',
				},
				responsive: [
					{
						breakpoint: 480,
						options: {
							chart: {
								width: 200,
							},
							legend: {
								position: 'bottom',
							},
						},
					},
				],
			},
			// chart 5
			series5: [],
			chartOptions5: {
				tooltip: {
					custom: function ({ series, seriesIndex, dataPointIndex, w }) {
						return `<div style="padding: 10px; background: ${seriesIndex == 0 ? '#3e8df3' : '#67e09c'}"><span>${
							seriesIndex == 0 ? 'Actual Payment CAPEX' : 'Total Remaining Payment CAPEX'
						}: Rp. ${series[seriesIndex].toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')}</span></div>`;
					},
				},
				chart: {
					width: 180,
					type: 'pie',
				},
				labels: ['Actual Payment CAPEX', 'Total Remaining Payment CAPEX'],
				legend: {
					position: 'bottom',
				},
				responsive: [
					{
						breakpoint: 480,
						options: {
							chart: {
								width: 200,
							},
							legend: {
								position: 'bottom',
							},
						},
					},
				],
			},
			// chart 6
			series6: [],
			chartOptions6: {
				tooltip: {
					custom: function ({ series, seriesIndex, dataPointIndex, w }) {
						return `<div style="padding: 10px; background: ${seriesIndex == 0 ? '#3e8df3' : '#67e09c'}"><span>${
							seriesIndex == 0 ? 'Actual Payment OPEX + CAPEX' : 'Total Remaining Payment OPEX + CAPEX'
						}: Rp. ${series[seriesIndex].toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')}</span></div>`;
					},
				},
				chart: {
					width: 180,
					type: 'pie',
				},
				labels: ['Actual Payment OPEX + CAPEX', 'Total Remaining Payment OPEX + CAPEX'],
				legend: {
					position: 'bottom',
				},
				responsive: [
					{
						breakpoint: 480,
						options: {
							chart: {
								width: 200,
							},
							legend: {
								position: 'bottom',
							},
						},
					},
				],
			},
		};
	},
	// created() {
	//   let role = localStorage.getItem("role_id")
	//   if (role > 0) {
	//     this.permission = true
	//   } else {
	//     this.permission = false
	//   }
	// },
	async mounted() {
		let data = await this.$store.getters['role/identity'];
		this.fullname = data?.fullname;
		if (!this.fullname) {
			await this.$store.dispatch('role/GET_IDENTIFY');
			data = await this.$store.getters['role/identity'];
		}
		if (data) {
			this.getActivePlan();
			this.monitoring();
			this.getTopBudget();
			this.getPlan();
			this.getListDepartment();
			if (data?.roles_uenroll?.length > 0 || data?.roleMap?.roles) {
				this.permission = true;
			} else {
				this.permission = false;
				//
			}
		} else {
			window.location.reload();
		}
	},
	methods: {
		async getActivePlan() {
			try {
				const response = await axiosIns.get('/plan/active-plan');
				this.activePlan = response?.data?.data;
			} catch (error) {
				console.error('Failed to fetch active plan:', error);
			}
		},
		async getListDepartment() {
			try {
				const response = await axiosIns.get('/fund-center/list-department');
				this.listDepartement = response.data.data
					.sort((a, b) => a.department_code.localeCompare(b.department_code)) // ASC sort
					.map((items) => ({
						label: `${items.department_code} - ${items.organization}`,
						value: items.id,
						row: items,
					}));
			} catch (error) {
				console.error('Failed to fetch year options:', error);
			}
		},
		downloadExcel(type) {
			this.$swal({
				title: 'Preparing download...',
				text: 'Please wait while we process your request',
				allowOutsideClick: false,
				allowEscapeKey: false,
				allowEnterKey: false,
				showConfirmButton: false,
				willOpen: () => {
					this.$swal.showLoading();
				},
			});

			this.$store
				.dispatch('budgetMonitor/GET_REPORT', type)
				.then(() => {
					let res = this.$store.getters['budgetMonitor/report'];
					const href = URL.createObjectURL(
						new Blob([res.data], {
							type: 'application/octet-stream',
						})
					);
					const link = document.createElement('a');
					link.href = href;
					link.setAttribute('download', `${moment().format()}-${type}.xlsx`);
					// link.setAttribute("download", `${Math.floor(10000000 + Math.random() * 90000000)}-Data Budget Plan.xlsx`);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					URL.revokeObjectURL(href);
					this.$swal.close();
				})
				.catch((error) => {
					console.error('Error:', error);
					this.$swal.close();
				});
		},
		monitoring() {
			this.$store
				.dispatch('budgetMonitor/GET_ALL_MONITORING')
				.then(() => {
					let data = this.$store.getters['budgetMonitor/allMonitoring'];
					if (data) {
						let dataopex = data?.general_plan?.summary.budget.actual_budget?.opex;
						let datacapex = data?.general_plan?.summary.budget.actual_budget?.capex;
						let dataopex2 = data?.general_plan?.summary.budget.remaining_budget?.opex;
						let datacapex2 = data?.general_plan?.summary.budget.remaining_budget?.capex;
						let dataactual = data?.general_plan?.summary.budget.actual_budget?.total;
						let dataplan = data?.general_plan?.summary.budget.remaining_budget?.total;
						let dataPayment = data?.general_plan?.summary.budget.actual_payment;
						let series1 = [];
						let series2 = [];
						let series3 = [];
						let series4 = [];
						let series5 = [];
						let series6 = [];
						series1.push(Number(datacapex) || 0, Number(datacapex2) || 1);
						series2.push(Number(dataopex) || 0, Number(dataopex2) || 1);
						series3.push(Number(dataactual) || 0, Number(dataplan) || 1);
						series4.push(Number(dataPayment.opex) || 0, Number(dataopex - dataPayment.opex) || 1);
						series5.push(Number(dataPayment.capex) || 0, Number(datacapex - dataPayment.capex) || 1);
						series6.push(Number(dataPayment.total) || 0, Number(dataactual - dataPayment.total) || 1);
						this.series = series1;
						this.series2 = series2;
						this.series3 = series3;
						this.series4 = series4;
						this.series5 = series5;
						this.series6 = series6;
					}
				})
				.then(() => {});
		},

		getTopBudget() {
			this.$store.dispatch('budgetMonitor/GET_TOP_OPEX');
			this.$store.dispatch('budgetMonitor/GET_TOP_CAPEX');
		},
		getPlan() {
			let body = {
				pageNumber: 1,
				pageSize: 999999,
			};
			this.$store.dispatch('budgetPlan/GET_LIST_DATA', body);
		},
		convertNumber(dat) {
			const number = dat || 0;
			return number.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
		},
		toggleAccordion(indx) {
			this.$root.$emit('bv::toggle::collapse', `accordion-${indx}`);
		},
		getAllDashboard() {
			this.$store
				.dispatch('budgetMonitor/GET_DASHBOARD_FILTER', this.formFilter)
				.then(() => {
					let data = this.$store.getters['budgetMonitor/allMonitoring'];
					if (data) {
						this.$store.commit('budgetMonitor/SET_MONITORING', data);
						let dataopex = data?.general_plan?.summary.budget.actual_budget?.opex;
						let datacapex = data?.general_plan?.summary.budget.actual_budget?.capex;
						let dataopex2 = data?.general_plan?.summary.budget.remaining_budget?.opex;
						let datacapex2 = data?.general_plan?.summary.budget.remaining_budget?.capex;
						let dataactual = data?.general_plan?.summary.budget.actual_budget?.total;
						let dataplan = data?.general_plan?.summary.budget.remaining_budget?.total;
						let dataPayment = data?.general_plan?.summary.budget.actual_payment;
						let series1 = [];
						let series2 = [];
						let series3 = [];
						let series4 = [];
						let series5 = [];
						let series6 = [];
						series1.push(Number(datacapex) || 0, Number(datacapex2) || 1);
						series2.push(Number(dataopex) || 0, Number(dataopex2) || 1);
						series3.push(Number(dataactual) || 0, Number(dataplan) || 1);
						series4.push(Number(dataPayment.opex) || 0, Number(dataopex - dataPayment.opex) || 1);
						series5.push(Number(dataPayment.capex) || 0, Number(datacapex - dataPayment.capex) || 1);
						series6.push(Number(dataPayment.total) || 0, Number(dataactual - dataPayment.total) || 1);
						this.series = series1;
						this.series2 = series2;
						this.series3 = series3;
						this.series4 = series4;
						this.series5 = series5;
						this.series6 = series6;
						this.$store.dispatch('budgetMonitor/GET_TOP_OPEX_DASHBOARD_FILTER', this.formFilter);
						this.$store.dispatch('budgetMonitor/GET_TOP_CAPEX_DASHBOARD_FILTER', this.formFilter);
						this.$swal
							.mixin({
								toast: true,
								position: 'top-end',
								showConfirmButton: false,
								timer: 3000,
								timerProgressBar: true,
								didOpen: (toast) => {
									toast.addEventListener('mouseenter', this.$swal.stopTimer);
									toast.addEventListener('mouseleave', this.$swal.resumeTimer);
								},
							})
							.fire({
								icon: 'success',
								title: 'Data has been replace',
							});
					}
				})
				.catch((err) => {
					this.$swal
						.mixin({
							toast: true,
							position: 'top-end',
							showConfirmButton: false,
							timer: 3000,
							timerProgressBar: true,
							didOpen: (toast) => {
								toast.addEventListener('mouseenter', this.$swal.stopTimer);
								toast.addEventListener('mouseleave', this.$swal.resumeTimer);
							},
						})
						.fire({
							icon: 'error',
							title: `${err}`,
						});
				});
			/*const oldAllMonitor = this.allMonitor;

			this.$store
				.dispatch('budgetMonitor/GET_DASHBOARD_FILTER', this.formFilter)
				.then((resp) => {
					const newDataMonitor = this.$store.getters['budgetMonitor/allMonitoring'];
					const data = { ...oldAllMonitor, ...newDataMonitor };

					this.allMonitor = data;
					if (!data.general_plan) {
						window.location.reload();
					}

					let dataopex = data.general_plan?.summary.budget.actual_budget?.opex;
					let datacapex = data.general_plan?.summary.budget.actual_budget?.capex;
					let dataopex2 = data.general_plan?.summary.budget.remaining_budget?.opex;
					let datacapex2 = data.general_plan?.summary.budget.remaining_budget?.capex;
					let dataactual = data.general_plan?.summary.budget.actual_budget?.total;
					let dataplan = data.general_plan?.summary.budget.remaining_budget?.total;
					let dataPayment = data?.general_plan?.summary.budget.actual_payment;
					let series1 = [];
					let series2 = [];
					let series3 = [];
					let series4 = [];
					let series5 = [];
					let series6 = [];
					series1.push(Number(datacapex) || 0, Number(datacapex2) || 1);
					series2.push(Number(dataopex) || 0, Number(dataopex2) || 1);
					series3.push(Number(dataactual) || 0, Number(dataplan) || 1);
					series4.push(Number(dataPayment.opex) || 0, Number(dataopex - dataPayment.opex) || 1);
					series5.push(Number(dataPayment.capex) || 0, Number(datacapex - dataPayment.capex) || 1);
					series6.push(Number(dataPayment.total) || 0, Number(dataactual - dataPayment.total) || 1);
					this.series = series1;
					this.series2 = series2;
					this.series3 = series3;
					this.series4 = series4;
					this.series5 = series5;
					this.series6 = series6;
					this.$swal
						.mixin({
							toast: true,
							position: 'top-end',
							showConfirmButton: false,
							timer: 3000,
							timerProgressBar: true,
							didOpen: (toast) => {
								toast.addEventListener('mouseenter', this.$swal.stopTimer);
								toast.addEventListener('mouseleave', this.$swal.resumeTimer);
							},
						})
						.fire({
							icon: 'success',
							title: 'Data has been replace',
						});
				})
				.catch((err) => {
					this.$swal
						.mixin({
							toast: true,
							position: 'top-end',
							showConfirmButton: false,
							timer: 3000,
							timerProgressBar: true,
							didOpen: (toast) => {
								toast.addEventListener('mouseenter', this.$swal.stopTimer);
								toast.addEventListener('mouseleave', this.$swal.resumeTimer);
							},
						})
						.fire({
							icon: 'error',
							title: `${err}`,
						});
				});
			this.$store.dispatch('budgetMonitor/GET_TOP_OPEX_DASHBOARD_FILTER', this.formFilter);
			this.$store.dispatch('budgetMonitor/GET_TOP_CAPEX_DASHBOARD_FILTER', this.formFilter);*/
		},
		openDetails(data, type) {
			this.title = '';
			this.details = data.budget;
			if (type == 'opex') {
				this.title = `Detail of ${data.budget_item.item} - ${data.budget_item.budget_item}`;
			} else {
				this.title = `Detail of ${data?.account?.code} - ${data?.account?.account}`;
			}
			this.$nextTick(() => {
				this.$bvModal.show('modal-detail');
			});
		},
		resetAll() {
			this.monitoring();
			this.getTopBudget();
			/*this.formFilter = {
				id: '',
				year: '',
				week: '',
				month: '',
        version:
			};*/
			this.tempYears = '';
			this.plan_title = '';
			this.listDataYear = [];
			this.listDataVersion = [];
			this.formFilter = {
				fund_center_id: '',
				title: '',
				version: '',
				year: '',
				month: '',
				week: '',
			};
			this.filter = {
				id: '',
				year: '',
				month: null,
				week: null,
			};
		},
		listPlan() {
			let part = this.$store.getters['budgetPlan/listData'].data;

			this.listPlanOptions = part.map((e) => {
				return {
					label: `${e.title} - Version ${e.version}`,
					id: e.id,
					year: e.year,
				};
			});
			// const intervalId = setInterval(() => {

			//   // Only run the map operation if `part.length > 0`
			//   if (part.length > 0) {
			//     clearInterval(intervalId); // Stop the interval once data is found

			//     // Map the part data to the options format required by v-select

			//   }
			// }, 500);
		},
		async selectedDepartment() {
			this.listDataPlan = [];
			this.listDataPlanDstinct = [];
			this.formFilter.title = '';
			this.listDataVersion = [];
			this.formFilter.version = '';
			this.listDataYear = [];
			this.formFilter.year = '';
			this.tempYears = '';
			if (this.formFilter.fund_center_id) {
				const dpt = await axiosIns.get(`/plan/fund-center/${this.formFilter.fund_center_id}`);
				if (dpt?.data?.data.length > 0) {
					/*
					this.listDataPlan = dpt?.data?.data;
					this.listDataPlanDstinct = [...new Map(dpt?.data?.data.map((item) => [item.title, item])).values()];
					*/
					/*let tempYears =  [...new Map(dpt?.data?.data.map((item) => [item.year, item])).values()];*/
					this.listDataPlan = dpt?.data?.data;
					let tempYears = [...new Map(dpt?.data?.data.map((item) => [item.year, item])).values()].sort(
						(a, b) => b.year - a.year
					);
					this.listDataYear = tempYears;
					//console.log("tempYears: ", tempYears)
					/*this.listDataYear = dt;

          let dt = this.listDataPlan.filter(
              (e) => e.title === this.formFilter.title && e.version === this.formFilter.version
          );
          if (dt.length > 0) {
            this.formFilter.year = dt[0].year;
            this.listDataYear = dt;
          }*/
				}
			}
		},
		selectedYear() {
			this.plan_title = this.tempYears?.title || '';
			this.formFilter.year = this.tempYears?.year;
			this.formFilter.version = '';
			this.listDataVersion = [];
			let filterPlan = this.listDataPlan.filter((item) => item.year === this.formFilter.year);
			this.listDataVersion = [...new Map(filterPlan.map((item) => [item.version, item])).values()].sort(
				(a, b) => b.version - a.version
			);
		},
		selectedPlan() {
			this.listDataVersion = [];
			this.formFilter.version = '';
			this.listDataYear = [];
			this.formFilter.year = '';
			if (this.formFilter.title !== '') {
				let dt = this.listDataPlan.filter((e) => e.title === this.formFilter.title);
				if (dt.length > 0) {
					this.listDataVersion = dt;
				}
			}
		},
		/*selectedVersion() {
			this.listDataYear = [];
			this.formFilter.year = '';
			if (this.formFilter.title !== '') {
				let dt = this.listDataPlan.filter(
					(e) => e.title === this.formFilter.title && e.version === this.formFilter.version
				);
				if (dt.length > 0) {
					this.formFilter.year = dt[0].year;
					this.listDataYear = dt;
				}
			}
		},*/
	},
};
</script>
<style>
.arrow_box {
	position: relative;
	background: #555;
	border: 2px solid #000000;
}

.arrow_box:after,
.arrow_box:before {
	right: 100%;
	top: 50%;
	border: solid transparent;
	content: ' ';
	height: 0;
	width: 0;
	position: absolute;
	pointer-events: none;
}

.arrow_box:after {
	border-color: rgba(85, 85, 85, 0);
	border-right-color: #555;
	border-width: 10px;
	margin-top: -10px;
}

.arrow_box:before {
	border-color: rgba(0, 0, 0, 0);
	border-right-color: #000000;
	border-width: 13px;
	margin-top: -13px;
}

.tab-title {
	color: #010101;
}

#chart .apexcharts-tooltip {
	color: #fff;
	transform: translateX(10px) translateY(10px);
	overflow: visible !important;
	white-space: normal !important;
}

#chart .apexcharts-tooltip span {
	padding: 5px 10px;
	display: inline-block;
}
</style>
